import { Injectable } from '@angular/core';


@Injectable({
  providedIn: 'root'
})
export class SessionStorageService {

  public storeApplicationId(id: string) {
    sessionStorage.setItem('storageId', id);
  }
  public getApplicationId(): string | null {
    return sessionStorage.getItem('storageId');
  }

  public storeRejectionReason(reason: string) {
    sessionStorage.setItem('reason', reason);
  }
  public getRejectionReason(): string | null {
    return sessionStorage.getItem('reason');
  }


  public storeInApp(inApp: any) {
    sessionStorage.setItem('inApp', inApp);
  }
  public getInApp(): string | null {
    return sessionStorage.getItem('inApp');
  }
  public removeInApp(inApp: string) {
    sessionStorage.removeItem(inApp);
  }


  public restoredApplicationId(id: string) {
    sessionStorage.setItem('restoredAppId', id);
  }
  public getrestoredApplicationId(): string | null {
    return sessionStorage.getItem('restoredAppId');
  }

  public storeProductName(product: string) {
    sessionStorage.setItem('productName', product);
  }
  public getProductName(): string | null {
    return sessionStorage.getItem('productName')
  }

  public storePersonalDetails(fname: string, lname: string) {
    sessionStorage.setItem('fname', fname);
    sessionStorage.setItem('lname', lname);
  }

  public storeBirthDate(birthDate: string){
    sessionStorage.setItem('birthDate',birthDate);
  }
  public getBirthDate(): string | null {
    return sessionStorage.getItem('sessionStor');
  }

  public getFirstname(): string | null {
    return sessionStorage.getItem('fname')
  }

  public getLastname(): string | null {
    return sessionStorage.getItem('lname')
  }
  public clear() {
    sessionStorage.clear();
  }

  // method to clear all session storage value expect the inApp value if inApp is true
  public clearAll() {
    const inApp = this.getInApp() ? this.getInApp() : '';
    sessionStorage.clear();
    this.storeInApp(inApp);
  }

  public storeDisposer(disposerNumber: string) {
    sessionStorage.setItem('disposerNumber', disposerNumber);
  }

  public getDisposer(): string | null {
   return sessionStorage.getItem('disposerNumber');
  }

  storeLegitimationRequired(legitimationRequired: string) {
    sessionStorage.setItem('legitimationRequired', legitimationRequired);
  }

  public getLegitimationRequired(): string | null {
    return sessionStorage.getItem('legitimationRequired');
  }

  public storeExpiryValue(isExpired: any) {
    sessionStorage.setItem('expired', isExpired);
  }
  public getExpireValue(): string | null {
    return sessionStorage.getItem('expired');
  }
}
